(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('NotFoundController', NotFoundController)

    /** @ngInject */
    function NotFoundController($rootScope) {
        const vm = this;

        init();

        function init() {
            $rootScope.alignLayoutCenter = true;
        }
    }
}());